import Joi from 'joi';

const details = {
  name: Joi.string()
    .label('Enriched Schema Name')
    .min(3)
    .max(100)
    .required(),
  option: Joi.string()
    .label('Enrichment Product')
    .required()
};

const design = {
  businessContextId: Joi.string()
    .label('businessContextId')
    .required(),
  enrichmentProduct: Joi.string()
    .label('enrichmentProduct')
    .required(),
  schemaName: Joi.string()
    .label('schemaName')
    .min(3)
    .max(100)
    .required(),
  tenantId: Joi.string()
    .label('tenantId')
    .required()
};

export default {
  details,
  design
};
